var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconVisualize(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun_Graph_2197521",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_43698",
    "data-name": "Group 43698",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43696",
    "data-name": "Group 43696",
    transform: "translate(0 2.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53392",
    "data-name": "Path 53392",
    d: "M12.8,20.6a7.809,7.809,0,0,0,7.8-7.8.6.6,0,0,0-.6-.6H13.4V5.6a.6.6,0,0,0-.6-.6,7.8,7.8,0,0,0,0,15.6Zm6.573-7.2A6.6,6.6,0,1,1,12.2,6.227V12.8a.6.6,0,0,0,.6.6Z",
    transform: "translate(-5 -5)",
    fill: "#f35d29"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_43697",
    "data-name": "Group 43697",
    transform: "translate(9.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53393",
    "data-name": "Path 53393",
    d: "M1.6,9.4H8.8a.6.6,0,0,0,.6-.6A7.809,7.809,0,0,0,1.6,1a.6.6,0,0,0-.6.6V8.8A.6.6,0,0,0,1.6,9.4ZM8.173,8.2H2.2V2.227A6.61,6.61,0,0,1,8.173,8.2Z",
    transform: "translate(-1 -1)",
    fill: "#f35d29"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVisualize);
export default __webpack_public_path__ + "static/media/icon-visualize.d6fcacc7.svg";
export { ForwardRef as ReactComponent };